import LoadingSpinner from '@components/loading-spinner/LoadingSpinner';



export const LoadingPage = () => {

	return (
		<div className="app-loading-page">
			<LoadingSpinner />
		</div>
	);
};